import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

const UScrollBar = (props, ref) => {
    const renderThumb = ({style, ...props}) => {
        const thumbStyle = {
            borderRadius: 100,
            backgroundColor: '#D1D1D1',
        };
        return <div className="u_scroll-bar" style={{...style, ...thumbStyle}} {...props} />;
    };



    return (
        <React.Fragment>
            {
                <Scrollbars
                    id={props.id}
                    className={`u_scroll-section ${props.className}`}
                    autoHide
                    renderThumbHorizontal={renderThumb}
                    renderThumbVertical={renderThumb}
                    universal={true}
                    hideTracksWhenNotNeeded={true}
                    onScroll={props.onScroll}
                    ref={ref}
                    onScrollStop={props.onScrollStop}
                >
                    {props.children}
                </Scrollbars>
            }
        </React.Fragment>
    );
};

export default React.forwardRef(UScrollBar);